export default __webpack_public_path__ + "static/media/jeff.4721d8b4.jpg";